// IE 2026 10 09 / ODOO-5800 (этап 2 «Снимок основания ЗП», DESIGN §2 «Почему был согласован док»): блок BASIS формы ячейки — «Basis at approval / Now / Δ»
// у ячейки с движением заказа поставщику (бэк cell_passport.basis, common_modules/cell_passport_basis.py): шапка — документ, строка, статус, версия, время снимка,
// утверждение LBE (plan_version, PM / BUM / MD, approved by … at …); таблица месяц × мера: basis / now / Δ / Δ %. Чистая логика без Vue / DOM — юнит tests/unit/cellBasis.test.mjs.
// Флаг fe.ux.cellPassportBasis (дефолт ВКЛ); выкл — параметр basis не уходит, блока нет.

const isObj = (x) => !!(x && typeof x === 'object' && !Array.isArray(x))
const num = (v) => (v === null || v === undefined || v === '' || Number.isNaN(Number(v))) ? null : Number(v)

// ответ бэка cell_passport.basis → модель блока; null — блока нет (выкл / нет PO / нет снимка / ошибка)
export function cellBasis_model(raw) {
    if (!isObj(raw) || raw.state !== 'ok' || !Array.isArray(raw.items) || !raw.items.length) return null
    const items = raw.items.filter(isObj).map(it => {
        const measures = (Array.isArray(it.measures) ? it.measures : []).map(String)
        const main = (Array.isArray(it.main) ? it.main : []).map(String).filter(m => measures.includes(m))
        const rows = (Array.isArray(it.rows) ? it.rows : []).filter(r => isObj(r) && r.date).map(r => {
            const o = { date: String(r.date).slice(0, 7), m: {} }
            for (const m of measures) { const c = isObj(r[m]) ? r[m] : {}; o.m[m] = { b: num(c.b), n: num(c.n), d: num(c.d), p: num(c.p) } }
            return o
        })
        const totals = {}
        for (const m of measures) { const c = isObj(it.totals) && isObj(it.totals[m]) ? it.totals[m] : {}; totals[m] = { b: num(c.b), n: num(c.n), d: num(c.d), p: num(c.p) } }
        const doc = isObj(it.doc) ? it.doc : {}
        return {
            id: String(it.id || ''), doc: { id: String(doc.id || ''), number: String(doc.number || ''), date: String(doc.date || '').slice(0, 10), line: num(doc.line), lines_count: num(doc.lines_count),
                supplier: String(doc.supplier_title || doc.supplier || ''), quantity: num(doc.quantity), delivery_date: String(doc.delivery_date || '').slice(0, 10), order_ref: String(doc.order_ref || '') },
            status: String(it.status || ''), status_prev: String(it.status_prev || ''), at: String(it.at || '').slice(0, 16).replace('T', ' '),
            version: String(it.version || ''), version_now: String(it.version_now || ''), object: String(it.object_title || it.object || ''), subject: String(it.subject_title || it.subject || ''),
            country: String(it.country_title || it.country || ''), approval: cellBasis_approval(it.approval), approval_now: cellBasis_approval(it.approval_now),
            approval_changed: (Array.isArray(it.approval_changed) ? it.approval_changed : []).map(String),
            measures, main: main.length ? main : measures.slice(0, 4), rows, totals, changed: Number(it.changed) || 0,
        }
    }).filter(it => it.rows.length && it.measures.length)
    if (!items.length) return null
    return { items, docs: Number(raw.docs) || items.length, time: Number(raw.time) || 0 }
}

export function cellBasis_approval(x) {
    if (!isObj(x)) return null
    return { binding: String(x.binding || ''), plan_version: String(x.plan_version || ''), pm: !!x.pm, bum: !!x.bum, md: !!x.md, by: String(x.by || ''), at: String(x.at || '').slice(0, 16) }
}

// число таблицы: тысячи пробелом, до 1 десятичной; null — «—»
export function cellBasis_fmt(v) {
    if (v === null || v === undefined || Number.isNaN(Number(v))) return '—'
    const n = Number(v)
    const r = Math.abs(n) >= 100 ? Math.round(n) : Math.round(n * 10) / 10
    const s = String(Math.abs(r)).replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
    return (r < 0 ? '−' : '') + s
}

// Δ со знаком («+1 200» / «−300» / «0»), Δ % («+12.5 %»); null — «—»
export function cellBasis_fmtDelta(d) {
    if (d === null || d === undefined || Number.isNaN(Number(d))) return '—'
    const n = Number(d)
    return n > 0 ? '+' + cellBasis_fmt(n) : cellBasis_fmt(n)
}
export function cellBasis_fmtPct(p) {
    if (p === null || p === undefined || Number.isNaN(Number(p))) return '—'
    const n = Math.round(Number(p) * 10) / 10
    return (n > 0 ? '+' : (n < 0 ? '−' : '')) + String(Math.abs(n)) + ' %'
}

// тон Δ: 'up' / 'down' / '' (ноль или нет); порог заметности — |Δ %| ≥ 10 → 'warn'
export function cellBasis_tone(c, warnPct = 10) {
    if (!isObj(c) || c.d === null || c.d === undefined || c.d === 0) return ''
    const big = c.p !== null && c.p !== undefined && Math.abs(Number(c.p)) >= warnPct
    return (c.d > 0 ? 'up' : 'down') + (big ? ' warn' : '')
}

// меры таблицы: по умолчанию main, по переключателю — все
export function cellBasis_measures(item, all = false) {
    if (!isObj(item)) return []
    return all ? item.measures : item.main
}

// сводка свёрнутого блока: «PO 227 · line 1 · Sent to supplier · 12 months · 3 changes» (строки UI — английские, перевод словарём вызывающего)
export function cellBasis_summary(model, t = (s, p) => String(s || '').replace(/\{(\w+)\}/g, (m, k) => (p && k in p) ? String(p[k]) : m)) {
    if (!model || !model.items.length) return ''
    const it = model.items[0]
    const parts = [t('PO {n}', { n: it.doc.number || it.doc.id.slice(0, 8) }) + (it.doc.line ? ' · ' + t('line {n}', { n: it.doc.line }) : '')]
    if (it.status) parts.push(it.status)
    parts.push(t(it.rows.length === 1 ? '{n} month' : '{n} months', { n: it.rows.length }))
    parts.push(it.changed ? t(it.changed === 1 ? '{n} change' : '{n} changes', { n: it.changed }) : t('no changes'))
    if (model.items.length > 1) parts.push('+' + (model.items.length - 1))
    return parts.join(' · ')
}

// подпись версии плана LBE: «LBE 2026-08 …» как есть, иное — с префиксом «LBE» (plan_version витрины уже начинается с LBE — на dev02 09.10 было «LBE LBE 2026-08»)
export function cellBasis_planLabel(pv) {
    const s = String(pv || '').trim()
    if (!s) return 'LBE'
    return /^LBE\b/i.test(s) ? s : 'LBE ' + s
}

// строка «approved by … at …» утверждения: кто и когда; без утверждения — «not approved»
export function cellBasis_approvalText(a, t = (s, p) => String(s || '').replace(/\{(\w+)\}/g, (m, k) => (p && k in p) ? String(p[k]) : m)) {
    if (!a) return ''
    const who = [a.pm ? 'PM' : '', a.bum ? 'BUM' : '', a.md ? 'MD' : ''].filter(Boolean).join(' / ')
    if (!who && !a.by) return t('not approved')
    const by = a.by ? t('approved by {who}', { who: a.by }) : t('approved')
    return by + (who ? ' (' + who + ')' : '') + (a.at ? ' ' + t('at {when}', { when: a.at }) : '')
}
